import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { trackNavigationVideoPlay, trackNavigationModuleClick, trackCategoriesPageClick, trackSolutionVideoPage } from 'common/track'
import styles from './index.module.scss'

interface INativeVideoProps {
  pn?: string
  language?: string
  sub_module?: string
  description: string | null
  layout?: string
  id: number
  title: string
  value: string
  art_id: number
  module: string
  isPlaying?: boolean
  style?: React.CSSProperties
  uid?: string
}

const NativeVideo = React.memo(
  ({
    pn,
    language,
    sub_module,
    value: url,
    layout,
    id,
    title,
    description,
    art_id,
    module,
    style,
    isPlaying,
    uid,
  }: INativeVideoProps) => {
    const videoRef = useRef<HTMLVideoElement>(null)
    const playStart = useRef(Date.now())
    const [isVideoPlaying, setIsVideoPlaying] = useState(false)

    const trackVideoPlay = useCallback(
      (duration: number) => {
        // 文章集合页点击视频埋点
        if (module === 'tutorial-catagory_page') {
          trackCategoriesPageClick(title, uid, language, sub_module)
        } else {
          trackNavigationVideoPlay(Math.ceil(duration / 1000), url, art_id, pn, language, sub_module)
        }
      },
      [module, title, uid, language, sub_module, url, art_id, pn]
    )

    // swiper 滑动时视频暂停播放
    useEffect(() => {
      if (isPlaying && videoRef.current && layout === 'horizontal') {
        videoRef.current.pause()
      }
    }, [isPlaying, layout])

    const handlePlay = useCallback(() => {
      setIsVideoPlaying(true)
      playStart.current = Date.now()
      
      if (sub_module === 'solution') {
        trackSolutionVideoPage(uid as string, url)
      } else {
        trackNavigationModuleClick(title || '', { id: art_id, module, value: url, pn, language, sub_module })
      }
    }, [sub_module, uid, url, title, art_id, module, pn, language])

    const handlePause = useCallback(() => {
      setIsVideoPlaying(false)
      trackVideoPlay(Date.now() - playStart.current)
      playStart.current = Date.now()
    }, [trackVideoPlay])

    const handleEnded = useCallback(() => {
      setIsVideoPlaying(false)
      trackVideoPlay(Date.now() - playStart.current)
      playStart.current = Date.now()
    }, [trackVideoPlay])

    const handleClick = useCallback(() => {
      if (videoRef.current) {
        if (isVideoPlaying) {
          videoRef.current.pause()
        } else {
          videoRef.current.play()
        }
      }
    }, [isVideoPlaying])

    return (
      <div className={styles.videoContent} style={style}>
        <div className={styles.video} onClick={handleClick}>
          <video
            ref={videoRef}
            src={url}
            controls
            onPlay={handlePlay}
            onPause={handlePause}
            onEnded={handleEnded}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div className={styles.title}>{title && <p>{title}</p>}</div>
      </div>
    )
  },
  (prevProps, nextProps) => {
    return prevProps.isPlaying === nextProps.isPlaying && prevProps.value === nextProps.value
  }
)

export default NativeVideo 